/** 
* 
* @typedef {Object} PaginationProps 
* @property {number} skip - a number showing elements skipped of total elements 
* @property {number} take - a number showing total elements per page 
* @property {number} total - a number showing total data (usually total count in DB) 
* @property {object[]]} takeOptions - a list of number to select take from
    Example: [{ label: "10 Rows", value: 10 }, { label: "20 Rows", value: 20 }]

* @property {onChange} onChangeTakeCb - callback function when takeOption is changed
* @property {OnChange} onChange - callback function to be called when skip or take is changed 
* @property {FlexEndRenderLogic} [flexEndRenderLogic] - component returned by this function will be rendered to the right of pagination render 

**/

import { Pagination as PaginationCtr, PaginationItem, PaginationLink } from "reactstrap";
import styles from './RichGrid.styles';
import Icons from '../icons/Icons';
import { VEC_ICON_NAME } from '../icons/constants';
import SelectDropdown from '../dropdown/selectdropdown/SelectDropdown';
import VerticalSeparator from '../separator/verticalseparator/VerticalSeparator';

export default function Pagination({
    skip = 0,
    take = 10,
    total = 10,
    onChange = (take, skip) => { },
    takeOptions = [{ label: "10", value: 10 }],
    onChangeTakeCb = () => { }
}) {

    let selectedPage = (skip / take) + 1;
    const totalPages = Math.ceil(total / take);
    let pageOptions = [];

    if (totalPages === 0) {
        selectedPage = 0
    }
    else {
        /**
         * @description
         * get previous factor of 3. like for 1, 2, 3 previous multiple is 0
         * multiply that by 3 to get number of pages crossed. Add 1 to get first page in this group
         */
        const firstPaginationPage = (Math.ceil(selectedPage / 3) - 1) * 3 + 1;
        for (let i = firstPaginationPage; i < (firstPaginationPage + 3); i++) {
            pageOptions.push(
                i <= totalPages ? i : null
            )
        }
    }

    return <div style={styles.paginationContainer}>
       {total ? <>
        <div style={styles.rowsSelectionContainer}>
            <span>Rows per
            page</span>
            <div style={styles.rowSelectionDropdownContainer}>
                <SelectDropdown
                    value={{ label: `${take} Rows` }}
                    onSelectCb={(name, option) => {
                        onChangeTakeCb(option.value)
                    }}
                    hideBorder
                    suffixProps={{ icon: VEC_ICON_NAME.CARET_DOWN, suffixIconStyles: styles.rowSelectionDropdownIcon }}
                    customInputStyles={styles.rowSelectionDropdown}
                    options={takeOptions}
                    isClearable={false}
                />
            </div>
            <div style={styles.totalRecords}>
                {skip + 1} - {Math.min(skip + take, total)} of {total}
            </div>
        </div>

        <VerticalSeparator />

        <div style={styles.pageNumbers}>
            <PaginationCtr size={'sm'}>
                <PaginationItem>
                    {selectedPage !== 1 ? <PaginationLink
                        disabled={selectedPage === 1}
                        onClick={e => {
                            e.preventDefault()
                            onChange(take, skip - take);
                        }}
                    >
                        <Icons familyName="vec" iconName={VEC_ICON_NAME.CIRCULAR_LEFT_ARROW} />
                        <span className="sr-only">Previous</span>
                    </PaginationLink> : null}
                </PaginationItem>

                {
                    pageOptions.map(option => <PaginationItem className={selectedPage === option ? "active" : ""}>
                        <PaginationLink
                            onClick={e => {
                                if(selectedPage !== option){
                                    e.preventDefault()
                                    onChange(take, take * (option - 1));
                                }
                            }}
                            disabled={option === null || selectedPage === option}
                        >
                            {option}
                        </PaginationLink>
                    </PaginationItem>)
                }

                <PaginationItem>
                   {selectedPage !== totalPages ? <PaginationLink
                        disabled={selectedPage === totalPages}
                        onClick={e => {
                            e.preventDefault()
                            onChange(take, skip + take);
                        }}
                    >
                        <Icons familyName="vec" iconName={VEC_ICON_NAME.CIRCULAR_RIGHT_ARROW} />
                        <span className="sr-only">Next</span>
                    </PaginationLink> : null}
                </PaginationItem>
            </PaginationCtr>
        </div>
        </> : null}
    </div>
}
